// @ts-check

import { useCallback } from "react";
import { useOrgConfigForTenant } from "./useOrgConfigForTenant";

/**
 * Hook for managing tenant announcements config.
 */
export const useOrgAnnouncementsForTenant = () => {
  const { loading, config, update, updating } = useOrgConfigForTenant();

  const updateAnnouncements = useCallback(
    /**
     * @param {org_config.tenant.Announcements} newAnnouncements
     * @returns {Promise<boolean>}
     */
    async (newAnnouncements) => {
      return update({
        announcements: newAnnouncements,
      });
    },
    [update]
  );

  return {
    loading,
    announcements: config?.announcements,
    update: updateAnnouncements,
    updating,
  };
};
